import React from 'react';
import { IProductSegmentTag, ProductSegmentDescription, ProductSegmentTagDescription } from '../interface';

import './styles.scss';

const ProductSegmentTag = ({
    className,
    tagText
}: IProductSegmentTag) => {

    const Tag = () => {
        if (tagText === ProductSegmentDescription.MEDICINE) {
            return (
                <div className={className}>
                    <ul className="tags">
                        {true &&
                            <li key={"index"} className="tag medicine" >
                                <span className="tag-title">{ProductSegmentTagDescription.MEDICINE}</span>
                            </li>
                        }
                    </ul>
                </div>
            );
        } else if (tagText === ProductSegmentDescription.ONCOLOGY) {
            return (
                <div className={className}>
                    <ul className="tags">
                        {true &&
                            <li key={"index"} className="tag onco" >
                                <span className="tag-title">{ProductSegmentTagDescription.ONCOLOGY}</span>
                            </li>
                        }
                    </ul>
                </div>
            );
        } else if (tagText === ProductSegmentDescription.MATERIAL) {
            return (
                <div className={className}>
                    <ul className="tags">
                        {true &&
                            <li key={"index"} className="tag material" >
                                <span className="tag-title">{ProductSegmentTagDescription.MATERIAL}</span>
                            </li>
                        }
                    </ul>
                </div>
            );
        } else if (tagText === ProductSegmentDescription.HIGH_PRICE) {
            return (
                <div className={className}>
                    <ul className="tags">
                        {true &&
                            <li key={"index"} className="tag highPrice" >
                                <span className="tag-title">{ProductSegmentTagDescription.HIGH_PRICE}</span>
                            </li>
                        }
                    </ul>
                </div>
            );
        } else if (tagText === ProductSegmentDescription.VACCINE) {
            return (
                <div className={className}>
                    <ul className="tags">
                        {true &&
                            <li key={"index"} className="tag vaccine" >
                                <span className="tag-title">{ProductSegmentTagDescription.VACCINE}</span>
                            </li>
                        }
                    </ul>
                </div>
            );
        } else if (tagText === ProductSegmentDescription.NUTRITION) {
            return (
                <div className={className}>
                    <ul className="tags">
                        {true &&
                            <li key={"index"} className="tag nutrition" >
                                <span className="tag-title">{ProductSegmentTagDescription.NUTRITION}</span>
                            </li>
                        }
                    </ul>
                </div>
            );
        } else if (tagText === ProductSegmentDescription.EPI) {
            return (
                <div className={className}>
                    <ul className="tags">
                        {true &&
                            <li key={"index"} className="tag material" >
                                <span className="tag-title">{ProductSegmentTagDescription.EPI}</span>
                            </li>
                        }
                    </ul>
                </div>
            );
        } else if (tagText === ProductSegmentDescription.OPME) {
            return (
                <div className={className}>
                    <ul className="tags">
                        {true &&
                            <li key={"index"} className="tag material" >
                                <span className="tag-title">{ProductSegmentTagDescription.OPME}</span>
                            </li>
                        }
                    </ul>
                </div>
            );
        } else if (tagText === ProductSegmentDescription.ESPECIALIDADES) {
            return (
                <div className={className}>
                    <ul className="tags">
                        {true &&
                            <li key={"index"} className="tag material" >
                                <span className="tag-title">{ProductSegmentTagDescription.ESPECIALIDADES}</span>
                            </li>
                        }
                    </ul>
                </div>
            );
        } else if (tagText === ProductSegmentDescription.DIAGNOSTICO) {
            return (
                <div className={className}>
                    <ul className="tags">
                        {true &&
                            <li key={"index"} className="tag material" >
                                <span className="tag-title">{ProductSegmentTagDescription.DIAGNOSTICO}</span>
                            </li>
                        }
                    </ul>
                </div>
            );
        }
    };

    return (
        <div>
            {(Tag())}
        </div>
    );
};

export default ProductSegmentTag;